import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from '@material-ui/styles';
import { CssBaseline } from '@material-ui/core';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Themes from './themes';
import App from './components/App';
import * as serviceWorker from './serviceWorker';
import { LayoutProvider } from './context/LayoutContext';
import { UserProvider } from './context/UserContext';

ReactDOM.render(
  <LayoutProvider>
    <UserProvider>
      <ThemeProvider theme={Themes.default}>
        <CssBaseline />
        <App />
        <ToastContainer
          // style={{
          //   width: 400,
          //   top: 60,
          //   right: 0,
          // }}
          position="bottom-right"
          hideProgressBar
          toastStyle={{
            display: 'flex',
            alignItems: 'center',
            background: 'transparent',
            boxShadow: 'none',
            overflow: 'visible',
          }}
          closeButton={false}
          closeOnClick
        />
      </ThemeProvider>
    </UserProvider>
  </LayoutProvider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
